import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetDataBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="url(#Asset_DataBase_svg__a)"
      fillOpacity={0.4}
      d="M3.998 5.535h12.003l.002 8.961s-.824 1.67-5.921 1.67-6.083-1.636-6.083-1.636V5.535Z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale03)"
      d="M16.002 14.504c0 .9-2.687 1.63-6.002 1.63s-6.002-.73-6.002-1.63 2.687-1.63 6.002-1.63 6.002.73 6.002 1.63m0-4.446c0 .736-2.687 1.334-6.002 1.334s-6.002-.598-6.002-1.334S6.685 8.724 10 8.724s6.002.597 6.002 1.334"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale02)"
      d="M16.002 5.538c0 .941-2.687 1.704-6.002 1.704S4 6.48 4 5.538s2.686-1.704 6-1.704 6.002.763 6.002 1.704"
    />
    <defs>
      <linearGradient
        id="Asset_DataBase_svg__a"
        x1={13.752}
        x2={-1.255}
        y1={12.89}
        y2={12.586}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetDataBase;
